var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEducation = function SvgEducation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.074 19.8663L12.199 6.94946C12.0881 6.57967 12.291 6.18866 12.6573 6.06657L15.5871 5.08997C15.9694 4.96254 16.3813 5.17637 16.4972 5.56236L20.3722 18.4791C20.4832 18.8489 20.2802 19.2399 19.9139 19.362L16.984 20.3386C16.6017 20.466 16.1898 20.2521 16.074 19.8663Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 16.2857L19.2855 14.8572",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9999 3.42859H4.14275C3.74827 3.42859 3.42847 3.74839 3.42847 4.14287V19.8572C3.42847 20.2516 3.74827 20.5714 4.14275 20.5714H6.9999C7.39438 20.5714 7.71418 20.2516 7.71418 19.8572V4.14287C7.71418 3.74839 7.39438 3.42859 6.9999 3.42859Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42847 16.2857H7.71418",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2855 5.57147H8.4284C8.03391 5.57147 7.71411 5.89127 7.71411 6.28576V19.8572C7.71411 20.2516 8.03391 20.5715 8.4284 20.5715H11.2855C11.68 20.5715 11.9998 20.2516 11.9998 19.8572V6.28576C11.9998 5.89127 11.68 5.57147 11.2855 5.57147Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEducation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "education.daac9ae432fae7a91b8675555b186dd3.svg";